import ColorPicker, { colors } from 'client/components/Modal/CompanyInformationModal/CustomSettingsModal/ColorPicker'
import { Analytics, checkPlacement } from 'client/Global/Analytics'
import { AnalyticsType, Category, Events, Result } from 'client/Global/AnalyticsEvents'
import { Segment } from 'client/Global/Segment'
import { SegmentEvents } from 'client/Global/SegmentEvents'
import { l } from 'client/Other/Translation'
import { useEffect, useState } from 'react'
import * as React from 'react'

export const ColorSelection = ({ settings, setSettings, changedValues, setChangedValues }) => {
  const [displayColorPicker, setDisplayColorPicker] = useState(false)
  const [color, setColor] = useState(settings.settings.color.text)

  useEffect(() => {
    setColor(settings.settings.color.text)
  }, [settings])

  const handleClick = () => {
    setDisplayColorPicker(!displayColorPicker)
  }

  const handleClose = () => {
    setDisplayColorPicker(false)
  }

  const isDefaultColor = (color) => {
    return !!colors.includes(color)
  }

  const handleChange = (color) => {
    Segment.track(SegmentEvents.invoiceCustomise.invoiceCustomised, { invoice_colour_changed: color })
    setColor(color.hex)
    setSettings({
      loaded: true,
      modified: true,
      customSettings: {
        ...settings,
        settings: {
          ...settings.settings,
          color: {
            text: color.hex,
          },
        },
      },
    })
    setChangedValues({ ...changedValues, color: true })
    Analytics.trackEvent(Events.selectMainColor, {
      type: AnalyticsType.action,
      category: Category.setting,
      result: Result.success,
      placement: checkPlacement(window.location.pathname),
      default: isDefaultColor(color.hex),
      hexColor: color.hex,
    })
  }

  return (
    <div className="SelectInput Controlled CustomTemplate">
      <span className="Label">{l('customTemplates.templateColor')}</span>
      <div className="ColorPicker">
        <div className="ColorPicker__swatch" onClick={handleClick}>
          <div style={{ background: `${color}` }} className="ColorPicker__selected" />
        </div>
        {displayColorPicker ? (
          <div className="ColorPicker__popover">
            <div className="ColorPicker__cover" onClick={handleClose} />
            <ColorPicker color={color} onChange={handleChange} />
          </div>
        ) : null}
      </div>
    </div>
  )
}
